import { createCachedSelector } from "re-reselect";

import { shouldIncludeFees } from "@app/helpers/price";
import { getLegSourceNamesFromTripPrices } from "@app/helpers/udm/get-leg-source-names";
import { getLocalizedPrice } from "@app/helpers/udm/get-localized-price";
import { getSearchedLeg } from "@app/helpers/udm/get-searched-leg";
import { isTripSoldOut } from "@app/helpers/udm/is-trip-sold-out";
import { isUDMV4 } from "@app/helpers/udm/v4-migration-helper/is-udm-v4";
import type { TripOption } from "@app/types/results-types";

import { getDisplayedPriceConfig } from "../get-displayed-price-config";
import { getSearch, getTripsFares, getTripsSegments } from "../state-accessors";
import { getTripById } from "../trips/get-trip";

export const getTripOptionPerSegmentId = createCachedSelector(
  getTripById,
  getTripsSegments,
  getSearch,
  getTripsFares,
  getDisplayedPriceConfig,
  (_, trip_id, segment_id) => {
    return { trip_id, segment_id };
  },
  (
    trip,
    trips_segments,
    search,
    fares,
    displayed_price_config,
    { trip_id, segment_id }
  ): TripOption => {
    const segment = trips_segments[segment_id];
    // TODO: UDMV4 this should work with udm v4
    // @ts-expect-error fare_id does not exist on segments
    const fare = fares[segment.fare_id];
    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const leg = getSearchedLeg(search, trip);

    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const segment_price = trip.prices.find(price =>
      price.segment_ids.includes(segment_id)
    );

    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const is_sold_out = isTripSoldOut(search, trip, trips_segments);

    const price_in_cents =
      segment_price === undefined
        ? 0
        : // TODO: UDMV4 this should work with udm v4
          // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          isUDMV4(trip)
          ? 0
          : // TODO: UDMV4 this should work with udm v4
            // @ts-expect-error fare_id does not exist
            getLocalizedPrice(segment_price.prices.breakdown, {
              include_fees: shouldIncludeFees(displayed_price_config)
            });

    const sources_names = getLegSourceNamesFromTripPrices(leg, trip);

    return {
      trip_id,
      // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      amenities: segment.vehicle.amenities as TripOption["amenities"],
      // TODO: UDMV4 this should work with udm v4
      // @ts-expect-error fare_id does not exist on segments
      class_name: segment.class?.name,
      // TODO: UDMV4 this should work with udm v4
      // @ts-expect-error fare_id does not exist on segments
      class_xid: segment.class?.xid,
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      fare_id: fare?.id,
      // TODO: UDMV4 this should work with udm v4
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      fare_name: fare?.name,
      // TODO: UDMV4 this should work with udm v4
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      fare_xid: fare?.xid,
      is_sold_out,
      price_in_cents,
      // TODO: UDMV4 this should work with udm v4
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      terms: fare?.terms,
      sources_names,
      prices_per_segment: { [segment_id]: { price_in_cents } }
    };
  }
)((_, trip_id, segment_id) => `${trip_id}-${segment_id}`);
